<template>
  <teleport to="body">
    <div class="centro-modal-backdrop">
      <div class="centro-modal-card">
        <button type="button" class="centro-modal-close" @click="$emit('cerrar')">✕</button>

        <div class="centro-modal-header">
          <p class="centro-modal-title">
            {{ centro ? 'Editar centro de activación' : 'Agregar centro de activación' }}
          </p>
          <p class="centro-modal-subtitle">
            Solo el nombre de la tienda es obligatorio. El resto de datos son opcionales y pueden completarse después.
          </p>
        </div>

        <form class="centro-form" @submit.prevent="guardarCentro">
          <div class="centro-form-section">
            <p class="centro-form-section-title">Datos comerciales</p>
            <div class="centro-form-grid">
              <div class="centro-form-field">
                <label class="centro-form-label">Store / nombre de tienda <span class="centro-required">*</span></label>
                <input v-model.trim="form.nombre" type="text" class="centro-input" required placeholder="Ej. Tienda Polanco" />
              </div>

              <div class="centro-form-field">
                <label class="centro-form-label">País</label>
                <input v-model.trim="form.pais" type="text" class="centro-input" placeholder="Mexico" />
              </div>

              <div class="centro-form-field centro-form-field--full">
                <label class="centro-form-label">Retailer</label>
                <div class="centro-inline-row">
                  <select v-model="form.id_retailer" class="centro-input centro-select">
                    <option value="">Sin retailer</option>
                    <option v-for="retailer in retailers" :key="retailer.id_retailer" :value="String(retailer.id_retailer)">
                      {{ retailer.nombre }}
                    </option>
                  </select>
                  <button type="button" class="centro-btn centro-btn--ghost centro-btn--small" @click="toggleCrearRetailer">
                    {{ creandoRetailer ? 'Cancelar nuevo retailer' : '+ Nuevo retailer' }}
                  </button>
                </div>

                <div v-if="creandoRetailer" class="centro-inline-create">
                  <input
                    v-model.trim="nuevoRetailerNombre"
                    type="text"
                    class="centro-input"
                    placeholder="Ej. El Palacio de Hierro"
                    @keydown.enter.prevent="crearRetailerRapido"
                  />
                  <button
                    type="button"
                    class="centro-btn centro-btn--primary centro-btn--small"
                    :disabled="savingRetailer || !nuevoRetailerNombre.trim()"
                    @click="crearRetailerRapido"
                  >
                    {{ savingRetailer ? 'Guardando…' : 'Guardar retailer' }}
                  </button>
                </div>
              </div>

              <div class="centro-form-field">
                <label class="centro-form-label">Número de tienda</label>
                <input v-model.trim="form.numero_tienda" type="text" class="centro-input" placeholder="Ej. 1006" />
              </div>

              <div class="centro-form-field">
                <label class="centro-form-label">Display</label>
                <input v-model.trim="form.display" type="text" class="centro-input" placeholder="Ej. Cabin" />
              </div>
            </div>
          </div>

          <div class="centro-form-section">
            <p class="centro-form-section-title">Ubicación</p>
            <div class="centro-form-grid">
              <div class="centro-form-field centro-form-field--full">
                <label class="centro-form-label">Dirección</label>
                <input v-model.trim="form.direccion" type="text" class="centro-input" placeholder="Calle, número, colonia…" />
              </div>

              <div class="centro-form-field">
                <label class="centro-form-label">Ciudad</label>
                <input v-model.trim="form.ciudad" type="text" class="centro-input" placeholder="Ej. Guadalajara" />
              </div>

              <div class="centro-form-field">
                <label class="centro-form-label">Estado</label>
                <input v-model.trim="form.estado" type="text" class="centro-input" placeholder="Ej. Jalisco" />
              </div>
            </div>
          </div>

          <div class="centro-form-section">
            <p class="centro-form-section-title">Contacto</p>
            <div class="centro-form-grid">
              <div class="centro-form-field">
                <label class="centro-form-label">Nombre de contacto</label>
                <input v-model.trim="form.contacto_nombre" type="text" class="centro-input" placeholder="Nombre de la persona responsable" />
              </div>

              <div class="centro-form-field">
                <label class="centro-form-label">Teléfono de contacto</label>
                <input v-model.trim="form.contacto_telefono" type="text" class="centro-input" placeholder="Ej. 33 1234 5678" />
              </div>

              <div class="centro-form-field centro-form-field--full">
                <label class="centro-form-label">Correo de contacto</label>
                <input v-model.trim="form.contacto_email" type="email" class="centro-input" placeholder="correo@ejemplo.com" />
              </div>
            </div>
          </div>

          <div class="centro-form-section centro-form-section--stacked">
            <div class="centro-form-field">
              <label class="centro-form-label">Horarios de entrega</label>
              <textarea
                v-model.trim="form.horarios_entrega"
                class="centro-input centro-textarea"
                rows="3"
                placeholder="Lunes a viernes: 9:00 - 18:00&#10;Sábado: 10:00 - 14:00"
              ></textarea>
            </div>

            <div class="centro-form-field">
              <label class="centro-form-label">Notas / observaciones</label>
              <textarea
                v-model.trim="form.notas"
                class="centro-input centro-textarea"
                rows="2"
                placeholder="Detalles especiales, referencias, condiciones de entrega…"
              ></textarea>
            </div>
          </div>

          <div class="centro-form-actions">
            <button type="button" class="centro-btn centro-btn--ghost" @click="$emit('cerrar')">Cancelar</button>
            <button type="submit" class="centro-btn centro-btn--primary" :disabled="saving">
              {{ saving ? 'Guardando…' : 'Guardar centro' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </teleport>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FormularioCentroActivacion',
  props: {
    centro: {
      type: Object,
      default: null,
    },
  },
  emits: ['cerrar', 'guardado'],
  data() {
    return {
      saving: false,
      savingRetailer: false,
      retailers: [],
      creandoRetailer: false,
      nuevoRetailerNombre: '',
      form: {
        nombre: '',
        pais: 'Mexico',
        id_retailer: '',
        numero_tienda: '',
        display: '',
        direccion: '',
        ciudad: '',
        estado: '',
        contacto_nombre: '',
        contacto_telefono: '',
        contacto_email: '',
        horarios_entrega: '',
        notas: '',
      },
    };
  },
  async mounted() {
    await this.cargarRetailers();
    if (this.centro) {
      this.form = {
        ...this.form,
        ...this.centro,
        pais: this.centro.pais || 'Mexico',
        id_retailer: this.centro.id_retailer ? String(this.centro.id_retailer) : '',
        horarios_entrega: this.normalizeMultiline(this.centro.horarios_entrega),
        notas: this.normalizeMultiline(this.centro.notas),
      };
    }
  },
  methods: {
    normalizeMultiline(value) {
      if (!value || typeof value !== 'string') return '';
      let v = value.trim();
      if ((v.startsWith('"') && v.endsWith('"')) || (v.startsWith("'") && v.endsWith("'"))) {
        v = v.slice(1, -1);
      }
      return v.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n').replace(/\\r/g, '');
    },
    async cargarRetailers() {
      try {
        const res = await axios.get('/api/almacen/retailers/listar');
        this.retailers = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error('Error al cargar retailers:', err);
        this.retailers = [];
      }
    },
    toggleCrearRetailer() {
      this.creandoRetailer = !this.creandoRetailer;
      if (!this.creandoRetailer) {
        this.nuevoRetailerNombre = '';
      }
    },
    async crearRetailerRapido() {
      const nombre = this.nuevoRetailerNombre.trim();
      if (!nombre) return;

      this.savingRetailer = true;
      try {
        const res = await axios.post('/api/almacen/retailers/crear', { nombre });
        if (res.data?.status === 'ok' && res.data?.data?.id_retailer) {
          await this.cargarRetailers();
          this.form.id_retailer = String(res.data.data.id_retailer);
          this.creandoRetailer = false;
          this.nuevoRetailerNombre = '';
          this.$toast?.success?.('Retailer guardado correctamente.');
        } else {
          this.$toast?.error?.(res.data?.msg || 'No se pudo guardar el retailer.');
        }
      } catch (err) {
        console.error('Error al crear retailer:', err);
        this.$toast?.error?.(err.response?.data?.msg || 'Error al crear el retailer.');
      } finally {
        this.savingRetailer = false;
      }
    },
    async guardarCentro() {
      if (!this.form.nombre.trim()) {
        this.$toast?.error?.('El nombre de la tienda es obligatorio.');
        return;
      }

      this.saving = true;
      try {
        const endpoint = this.centro
          ? '/api/almacen/centros/actualizar'
          : '/api/almacen/centros/crear';

        const payload = {
          ...this.form,
          pais: (this.form.pais || 'Mexico').trim() || 'Mexico',
          id_retailer: this.form.id_retailer || null,
        };

        const res = await axios.post(endpoint, payload);

        if (res.data?.status === 'ok') {
          this.$emit('guardado');
        } else {
          this.$toast?.error?.(res.data?.msg || 'No se pudo guardar el centro.');
        }
      } catch (err) {
        console.error('Error al guardar centro:', err);
        this.$toast?.error?.(err.response?.data?.msg || 'Error al guardar el centro.');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.centro-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: radial-gradient(circle at 0 0, rgba(15, 23, 42, 0.65), rgba(15, 23, 42, 0.96));
  backdrop-filter: blur(18px);
}

.centro-modal-card {
  position: relative;
  width: 100%;
  max-width: 760px;
  max-height: min(90vh, 720px);
  border-radius: 1.6rem;
  padding: 1.4rem 1.5rem 1.3rem;
  background: radial-gradient(circle at 0 0, rgba(148, 163, 184, 0.36), rgba(15, 23, 42, 0.98));
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.95), 0 0 0 1px rgba(15, 23, 42, 0.9);
  overflow-y: auto;
}

.centro-modal-card::-webkit-scrollbar { width: 6px; }
.centro-modal-card::-webkit-scrollbar-thumb { background: rgba(148, 163, 184, 0.7); border-radius: 999px; }
.centro-modal-card::-webkit-scrollbar-track { background: transparent; }

.centro-modal-close {
  position: absolute;
  top: 0.7rem;
  right: 0.75rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.95);
  color: #e5e7eb;
  width: 26px;
  height: 26px;
  font-size: 0.8rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.centro-modal-header { margin-bottom: 1rem; padding-right: 1.5rem; }
.centro-modal-title { font-size: 1.05rem; font-weight: 600; color: #e5e7eb; }
.centro-modal-subtitle { margin-top: 0.25rem; font-size: 0.8rem; color: #94a3b8; }

.centro-form { display: flex; flex-direction: column; gap: 1rem; }
.centro-form-section {
  padding: 0.8rem 0.85rem;
  border-radius: 1rem;
  background: rgba(15, 23, 42, 0.88);
  border: 1px solid rgba(148, 163, 184, 0.55);
}
.centro-form-section--stacked { display: flex; flex-direction: column; gap: 0.7rem; }
.centro-form-section-title {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #9ca3af;
  margin-bottom: 0.5rem;
}
.centro-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.7rem 0.9rem; }
.centro-form-field { display: flex; flex-direction: column; gap: 0.24rem; }
.centro-form-field--full { grid-column: 1 / -1; }
.centro-form-label { font-size: 0.8rem; color: #cbd5f5; }
.centro-required { color: #f97373; }

.centro-input {
  width: 100%;
  border-radius: 0.75rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.94);
  padding: 0.45rem 0.7rem;
  font-size: 0.82rem;
  color: #e5e7eb;
  outline: none;
}
.centro-input::placeholder { color: #64748b; }
.centro-input:focus { border-color: #60a5fa; box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.6); }
.centro-select { appearance: none; }
.centro-textarea { min-height: 70px; resize: vertical; }

.centro-inline-row,
.centro-inline-create {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.55rem;
  align-items: center;
}
.centro-inline-create { margin-top: 0.55rem; }

.centro-form-actions { margin-top: 0.5rem; display: flex; justify-content: flex-end; gap: 0.5rem; }
.centro-btn {
  border-radius: 999px;
  font-size: 0.82rem;
  padding: 0.42rem 0.95rem;
  border: 1px solid transparent;
  cursor: pointer;
}
.centro-btn--small { padding-inline: 0.8rem; white-space: nowrap; }
.centro-btn--ghost { background: rgba(15, 23, 42, 0.85); border-color: rgba(148, 163, 184, 0.7); color: #e5e7eb; }
.centro-btn--primary { background: linear-gradient(135deg, #60a5fa, #4f46e5); color: #f9fafb; box-shadow: 0 12px 26px rgba(37, 99, 235, 0.75); }
.centro-btn--primary:disabled,
.centro-btn--ghost:disabled { opacity: 0.7; cursor: default; box-shadow: none; }

@media (max-width: 768px) {
  .centro-modal-card { max-height: 90vh; padding: 1.1rem 1.1rem 1rem; }
  .centro-form-grid,
  .centro-inline-row,
  .centro-inline-create { grid-template-columns: 1fr; }
}
</style>
